var React = require('react');

function IconMarker (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M12 0C7.802 0 4 3.403 4 7.602 4 11.8 7.469 16.812 12 24c4.531-7.188 8-12.2 8-16.398C20 3.403 16.199 0 12 0zm0 11a3 3 0 110-6 3 3 0 010 6z","key":1})]);
}

IconMarker.defaultProps = {"className":"marker__btn--icon","aria-label":"spendlik","viewBox":"0 0 24 24"};

module.exports = IconMarker;

IconMarker.default = IconMarker;
